// material-ui
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import {Autocomplete, createFilterOptions} from '@mui/material';
import FormControl from '@mui/material/FormControl';

// project-imports
import Avatar from 'components/@extended/Avatar';
import {PopupTransition} from 'components/@extended/Transitions';

// assets
import {HomeTrendDown} from 'iconsax-react';
import {FormattedMessage} from 'react-intl';
import {useAppDispatch, useAppSelector} from "../../../reducers/hooks";
import {getAllElementBoxNotPageable} from "../../../reducers/Box/BoxReducer";
import {useEffect, useState} from "react";

interface Props {
    id: string;
    title: string;
    open: boolean;
    handleClose: () => void;
    dateDogs: string[];
    onEnter: (idDogs: string[], boxId: string | null) => void;
    onDeselectAll: () => void;
}


export default function ModalChangeBox({id, title, open, handleClose, onEnter, onDeselectAll, dateDogs}: Props) {
    const dispatch = useAppDispatch();

    interface Boxed {
        _id: string;
        name: string;
        shedName: string;
    }

    // Stato per i box e il box selezionato
    const boxes = useAppSelector((state) => state.boxElement.elements || []);
    const [selectedBoxId, setSelectedBoxId] = useState<string | null>(null);

    // Carica i box una volta aperta la modale
    useEffect(() => {
        if (open) {
            dispatch(getAllElementBoxNotPageable());
        }
    }, [open]);

    // Funzione per confermare la selezione
    const confirmHandler = () => {
        onEnter(dateDogs, selectedBoxId)
        onDeselectAll()
        handleClose()

    };

    const filterOptions = createFilterOptions<Boxed>({
        matchFrom: 'start',
        ignoreCase: true,
    });

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            keepMounted
            TransitionComponent={PopupTransition}
            maxWidth="md"
            aria-labelledby="column-changeBox-title"
            aria-describedby="column-changeBox-description"
        >
            <DialogContent sx={{mt: 2, my: 1}}>
                <Stack alignItems="center" spacing={3.5}>
                    <Avatar color="success" sx={{width: 72, height: 72, fontSize: '1.75rem'}}>
                        <HomeTrendDown variant="Bold"/>
                    </Avatar>
                    <Stack spacing={2}>
                        <Typography variant="h4" align="center">
                            <FormattedMessage id="Select the box to which you want to move the dogs"
                                              defaultMessage="Select the box to which you want to move the dogs"/>
                            <Typography variant="h4" component="span">

                                &quot;{title}&quot;{' '}
                            </Typography>
                            ?
                        </Typography>
                    </Stack>

                    <FormControl fullWidth variant="outlined" margin="normal">
                        <Autocomplete<Boxed>
                            id="box-autocomplete"
                            value={boxes.find((box) => box._id === selectedBoxId) || null}
                            onChange={(event, newValue) => {
                                setSelectedBoxId(newValue ? newValue._id : null);
                            }}
                            options={boxes}
                            getOptionLabel={(option) => `${option.name} ${option.shedName}`}
                            isOptionEqualToValue={(option, value) => option._id === value._id}
                            filterOptions={filterOptions}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={<FormattedMessage id="Select Box" defaultMessage="Select Box"/>}
                                    variant="outlined"
                                    fullWidth
                                    margin="dense"
                                />
                            )}
                            noOptionsText={<FormattedMessage id="NoBoxesFound" defaultMessage="No boxes found"/>}
                        />
                    </FormControl>

                    <Stack direction="row" spacing={2} sx={{width: 1}}>
                        <Button fullWidth onClick={handleClose} color="secondary" variant="outlined">
                            <FormattedMessage id="Cancel" defaultMessage="Cancel"/>
                        </Button>
                        <Button
                            fullWidth
                            color="success"
                            variant="contained"
                            onClick={confirmHandler}
                            autoFocus
                        >
                            <FormattedMessage id="Confirm" defaultMessage="Confirm"/>
                        </Button>
                    </Stack>
                </Stack>
            </DialogContent>
        </Dialog>
    );
}
